import React from 'react'
import PropTypes from 'prop-types'
import Header from 'common/modules/bidBanner/header'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'

export const NoBids = ({ nextBidAmount }) => {
  const formattedNextBidAmount = formatMoneyWithNumeral(
    nextBidAmount,
    ZERO_DOLLARS
  )

  return (
    <Header
      icon={<Header.IconGavel color='adcLightBlue' />}
      subText={`Your bid must be ${formattedNextBidAmount} or higher`}
      text='The auction started.'
      color='adcLightBlue'
    />
  )
}

NoBids.propTypes = {
  nextBidAmount: PropTypes.number,
}

export const BidPlacedPending = () => {
  return (
    <Header
      icon={<Header.IconSmile color='success' />}
      subText='Do you want to bid again?'
      text='Your bid has been placed.'
      color='success'
    />
  )
}

export const BidPlacedNotMet = () => {
  return (
    <Header
      icon={<Header.IconSmile color='success' />}
      subText='Do you want to bid again?'
      text="You have the high bid, but the Estimated Credit Bid hasn't been exceeded."
      color='success'
    />
  )
}

export const BidPlacedMet = () => {
  return (
    <Header
      icon={<Header.IconSmile color='success' />}
      text='You are the highest bidder.'
      color='success'
    />
  )
}

export const Outbid = () => {
  return (
    <Header
      icon={<Header.IconExclamation color='caution' />}
      subText='Bid again.'
      text='You have been outbid.'
      color='caution'
    />
  )
}

export const Won = () => {
  return (
    <Header
      icon={<Header.IconGavel color='success' />}
      subText="What's next? Check your email for next steps on completing the sale."
      text='Congratulations! You won the auction.'
      color='success'
    />
  )
}
